import { combineReducers } from 'redux';
import authReducer from './auth_reducer';
import alertReducer from './alert_reducer';

export default combineReducers({
  authState: authReducer,
  alertState: alertReducer,
});